"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onMount: function() {}
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/components/Recommanded.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Swiper = require("swiper"),
    Swiper = module_Swiper.default || module_Swiper,
    Navigation = module_Swiper.Navigation,
    Pagination = module_Swiper.Pagination,
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Card_Swiper_template = require("../../../../components/Card-Swiper.marko"),
    Card_Swiper_tag = marko_loadTag(Card_Swiper_template),
    marko_attrs0 = {
        "class": "mt-4 d-none",
        id: "recommanded-courses"
      },
    marko_attrs1 = {
        "class": "pl-1"
      },
    marko_attrs2 = {
        "class": "swiper-list swiper-container swiper-container-horizontal"
      },
    marko_attrs3 = {
        "class": "swiper-wrapper"
      };

require("swiper/swiper-bundle.css");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  out.be("h6", marko_attrs1, "1", component);

  Locale_tag({
      text: "Recommanded Courses"
    }, out, __component, "2");

  out.ee();

  out.be("div", marko_attrs2, "3", component);

  out.be("div", marko_attrs3, "4", component);

  Card_Swiper_tag({}, out, __component, "5");

  Card_Swiper_tag({}, out, __component, "6");

  Card_Swiper_tag({}, out, __component, "7");

  Card_Swiper_tag({}, out, __component, "8");

  Card_Swiper_tag({}, out, __component, "9");

  Card_Swiper_tag({}, out, __component, "10");

  Card_Swiper_tag({}, out, __component, "11");

  Card_Swiper_tag({}, out, __component, "12");

  Card_Swiper_tag({}, out, __component, "13");

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
